module.exports = __webpack_public_path__ + "static/img/LUCA-SLADE.33eb763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/LUCA-SLADE.jpg
// module id = F/fR
// module chunks = 0